import { RouteMeta } from '@/shared/interfaces/route-meta'
import { Role } from '@/shared/models/role'
import { Route } from 'vue-router'
import { PositionResult } from 'vue-router/types/router'

class RouteMetaBuilderImpl {
  private defaultOptions: RouteMeta = {
    scroll: 0,
  }

  constructor(private options: RouteMeta = {}) {
    this.options = {
      ...this.defaultOptions,
      ...this.options,
    }
  }

  public admin(): RouteMetaBuilderImpl {
    return this.roles(...(this.options.auth?.roles || []), Role.ADMIN)
  }

  public build(): RouteMeta {
    return this.options
  }

  public dontScroll(): RouteMetaBuilderImpl {
    return this.with({
      scroll: false,
    })
  }

  public noFooter(): RouteMetaBuilderImpl {
    return this.with({
      footer: false,
    })
  }

  public noHeader(): RouteMetaBuilderImpl {
    return this.with({
      footer: false,
    })
  }

  public premium(): RouteMetaBuilderImpl {
    return this.roles(...(this.options.auth?.roles || []), Role.PREMIUM)
  }

  public roles(...roles: Role[]): RouteMetaBuilderImpl {
    // We can't use this.with because it does a shallow merge.
    return new RouteMetaBuilderImpl({
      ...this.options,
      auth: {
        ...this.options.auth,
        roles,
      },
    })
  }

  public scrollToTop(): RouteMetaBuilderImpl {
    return new RouteMetaBuilderImpl({
      ...this.options,
      scroll: (to: Route, from: Route, savedPosition) => {
        let newPosition: PositionResult

        if (!to.query.page && to.name !== from.name && savedPosition == null) {
          newPosition = {
            x: 0,
            y: 0,
          }
        } else if (savedPosition) {
          newPosition = {
            x: 0,
            y: savedPosition.y,
          }
        }

        return newPosition
      },
    })
  }

  public user(): RouteMetaBuilderImpl {
    return this.roles(...(this.options.auth?.roles || []), Role.USER)
  }

  private with(options: Partial<RouteMeta>): RouteMetaBuilderImpl {
    return new RouteMetaBuilderImpl({
      ...this.options,
      ...options,
    })
  }
}

export const RouteMetaBuilder = new RouteMetaBuilderImpl()
